import { useSite } from '../../context/SiteContext';
import Skeleton from 'react-loading-skeleton';
// import phoneinhand from '../../assets/images/phoneinhand.png';
import phoneinhand from '../../assets/phone_in_hand_new.png';
import AppStoreIcon from '../../assets/images/store/appstore.png';
import PlayStoreIcon from '../../assets/images/store/playstore.png';

export function DownloadAppSectionView() {
  const { settings, loading } = useSite();

  const appStoreUrl = (!settings?.app_store_url || settings.app_store_url.includes('id123456789'))
    ? "https://apps.apple.com/us/app/wayabank/id1658552439"
    : settings.app_store_url;

  const playStoreUrl = (!settings?.play_store_url || settings.play_store_url.includes('com.wayabank.app'))
    ? "https://play.google.com/store/apps/details?id=ng.wayabank"
    : settings.play_store_url;

  return (
    <div id="download" className="waya-download-wrapper">
      <div className="waya-download-left" style={{ zIndex: 1 }}>
        <h2 style={{ fontSize: 'clamp(26px, 4vw, 48px)', fontWeight: '500', color: 'white' }}>
          {loading ? <Skeleton width="80%" /> : (
            <>Download the <span className="waya-hero-highlight">{settings?.site_name || "WayaBank"}</span> App</>
          )}
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.60)', fontSize: '16px', lineHeight: '1.7', maxWidth: '400px' }}>
          {loading ? <Skeleton count={2} /> : "Available on iOS and Android. Open an account in minutes and start transacting seamlessly across Nigeria."}
        </p>
        <div className="d-flex gap-3 mt-4 flex-wrap">
          <a href={appStoreUrl} className="waya-store-btn" target="_blank" rel="noreferrer">
            <img src={AppStoreIcon} alt="App Store" style={{ height: '24px' }} />
            <div className="d-flex flex-column align-items-start">
              <span style={{ fontSize: '11px', opacity: '0.60', lineHeight: 1 }}>Download on the</span>
              <span style={{ fontSize: '15px', fontWeight: '500', lineHeight: 1 }}>App Store</span>
            </div>
          </a>
          <a href={playStoreUrl} className="waya-store-btn" target="_blank" rel="noreferrer">
            <img src={PlayStoreIcon} alt="Google Play" style={{ height: '24px' }} />
            <div className="d-flex flex-column align-items-start">
              <span style={{ fontSize: '11px', opacity: '0.60', lineHeight: 1 }}>GET IT ON</span>
              <span style={{ fontSize: '15px', fontWeight: '500', lineHeight: 1 }}>Google Play</span>
            </div>
          </a>
        </div>
      </div>
      <div className="waya-download-right" style={{ zIndex: 1 }}>
        <img src={phoneinhand} className="waya-phone-mockup img-fluid" alt="WayaBank App" style={{ maxWidth: '300px' }} />
      </div>
    </div>
  );
}
